import React, { useEffect, useState } from "react";
import { IconDeviceDesktopAnalytics, IconMicrophone, IconTrophy, IconLogin, IconX } from "@tabler/icons-react";
import { IconHelp } from "@tabler/icons-react";
import Loader from "./Loader";

//const IP = "http://localhost:8000";
const IP = "https://reportes.aux-rolplay.com";

const fmt = (val) => {
  const n = parseFloat(val);
  if (isNaN(n)) return val;
  return Number.isInteger(n) ? n : n.toFixed(2);
};

const DashboardInter = () => {
  const [simulators, setSimulators] = useState([]);
  const [rolplays, setRolplays] = useState([]);
  const [loginData, setLoginData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isExiting, setIsExiting] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);

  useEffect(() => {
    Promise.all([
      fetch(`${IP}/proxy/simulators`).then((response) => response.json()),
      fetch(`${IP}/proxy/rolplays`).then((response) => response.json()),
      fetch(`${IP}/proxy/login`).then((response) => response.json()),
    ])
      .then(([simulatorsData, rolplaysData, loginDataResponse]) => {
        setSimulators(simulatorsData);
        setRolplays(rolplaysData);
        setLoginData(loginDataResponse);
        setIsExiting(true);
        setTimeout(() => {
          setIsLoading(false);
        }, 500);
      })
      .catch((error) => {
        console.error("Error:", error);
        setIsExiting(true);
        setTimeout(() => {
          setIsLoading(false);
        }, 500);
      });
  }, []);

  if (isLoading) {
    return <Loader isExiting={isExiting} />;
  }

  return (
    <div className="w-full max-w-7xl mx-auto p-6">
      <div className="bg-white rounded-2xl shadow-lg p-8">
        <div className="flex items-center justify-between mb-8">
          <h1 className="text-2xl font-bold text-gray-900">
            Panel de Métricas - Interprotección
          </h1>
          <div className="flex items-center gap-4">
            <button
              onClick={() => setShowLoginModal(true)}
              className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-green-500 to-green-600 text-white rounded-lg hover:from-green-600 hover:to-green-700 transition-all duration-300 shadow-md hover:shadow-lg font-medium"
            >
              <IconLogin size={20} />
              Historial de Accesos
            </button>
            <div className="px-4 py-2 bg-gradient-to-r from-purple-50 to-purple-100 rounded-full border border-purple-300">
              <p className="text-sm text-purple-700 font-medium">
                Datos en tiempo real de actividades
              </p>
            </div>
          </div>
        </div>

        {/* Simuladores Section */}
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-6">
            <IconDeviceDesktopAnalytics className="text-blue-600" size={28} />
            <h2 className="text-xl font-semibold text-gray-900">
              Simuladores
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {simulators.map((simulator, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-6 border border-blue-200 hover:shadow-lg transition-all duration-300 hover:scale-105"
              >
                <div className="flex items-start justify-between mb-4">
                  <h3 className="text-lg font-bold text-gray-900 flex-1">
                    {simulator.title}
                  </h3>
                  <div className="bg-blue-600 text-white text-xs font-bold px-3 py-1 rounded-full">
                    SIM-{simulator.simulador}
                  </div>
                </div>

                <div className="space-y-3">
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-600 font-medium">Promedio de puntos:</span>
                    <span className="text-2xl font-bold text-blue-600">{fmt(simulator.avg)}</span>
                  </div>

                  <div className="w-full h-2 bg-blue-200 rounded-full overflow-hidden">
                    <div
                      className="h-full bg-gradient-to-r from-blue-500 to-blue-600"
                      style={{ width: `${Math.min(simulator.avg, 100)}%` }}
                    />
                  </div>

                  <div className="grid grid-cols-2 gap-3 pt-2">
                    <div className="bg-white rounded-lg p-3 border border-blue-200">
                      <p className="text-xs text-gray-500 mb-1">Intentos</p>
                      <p className="text-xl font-bold text-gray-900">{simulator.attemps}</p>
                    </div>
                    <div className="bg-white rounded-lg p-3 border border-blue-200">
                      <p className="text-xs text-gray-500 mb-1">Usuarios</p>
                      <p className="text-xl font-bold text-gray-900">{simulator.users}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {simulators.length === 0 && (
            <div className="text-center py-12 bg-gray-50 rounded-xl">
              <IconDeviceDesktopAnalytics className="mx-auto text-gray-400 mb-3" size={48} />
              <p className="text-gray-500">No hay simuladores disponibles</p>
            </div>
          )}
        </div>

        {/* Rolplays Section */}
        <div className="bg-gray-50 rounded-2xl p-8">
          <div className="flex items-center gap-3 mb-6">
            <IconMicrophone className="text-purple-600" size={28} />
            <h2 className="text-xl font-semibold text-gray-900">
              Rolplays
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {rolplays.map((rolplay, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl p-6 border border-purple-200 hover:shadow-lg transition-all duration-300 hover:scale-105"
              >
                <div className="flex items-start justify-between mb-4">
                  <h3 className="text-lg font-bold text-gray-900 flex-1">
                    {rolplay.title}
                  </h3>
                  <div className="bg-purple-600 text-white text-xs font-bold px-3 py-1 rounded-full">
                    RP-{rolplay.rolplay}
                  </div>
                </div>

                <div className="space-y-3">
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-600 font-medium">Promedio de puntos:</span>
                    <span className="text-2xl font-bold text-purple-600">{fmt(rolplay.avg)}</span>
                  </div>

                  <div className="w-full h-2 bg-purple-200 rounded-full overflow-hidden">
                    <div
                      className="h-full bg-gradient-to-r from-purple-500 to-purple-600"
                      style={{ width: `${Math.min(rolplay.avg, 100)}%` }}
                    />
                  </div>

                  <div className="grid grid-cols-2 gap-3 pt-2">
                    <div className="bg-white rounded-lg p-3 border border-purple-200">
                      <p className="text-xs text-gray-500 mb-1">Intentos</p>
                      <p className="text-xl font-bold text-gray-900">{rolplay.attemps}</p>
                    </div>
                    <div className="bg-white rounded-lg p-3 border border-purple-200">
                      <p className="text-xs text-gray-500 mb-1">Usuarios</p>
                      <p className="text-xl font-bold text-gray-900">{rolplay.users}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {rolplays.length === 0 && (
            <div className="text-center py-12 bg-white rounded-xl">
              <IconMicrophone className="mx-auto text-gray-400 mb-3" size={48} />
              <p className="text-gray-500">No hay rolplays disponibles</p>
            </div>
          )}
        </div>
      </div>

      {/* Login History Modal */}
      {showLoginModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[80vh] overflow-hidden">
            {/* Modal Header */}
            <div className="bg-gradient-to-r from-green-500 to-green-600 p-6 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <IconLogin className="text-white" size={32} />
                <h2 className="text-2xl font-bold text-white">Historial de Accesos</h2>
              </div>
              <button
                onClick={() => setShowLoginModal(false)}
                className="text-white hover:bg-white hover:bg-opacity-20 rounded-lg p-2 transition-all duration-200"
              >
                <IconX size={24} />
              </button>
            </div>

            {/* Modal Body */}
            <div className="p-6 overflow-y-auto max-h-[calc(80vh-100px)]">
              {loginData.length > 0 ? (
                <div className="overflow-x-auto">
                  <table className="w-full">
                    <thead className="sticky top-0 bg-white">
                      <tr className="border-b-2 border-green-300">
                        <th className="text-left py-3 px-4 text-sm font-bold text-gray-700 bg-green-50">Fecha</th>
                        <th className="text-right py-3 px-4 text-sm font-bold text-gray-700 bg-green-50">Usuarios</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loginData.map((item, index) => (
                        <tr
                          key={index}
                          className="border-b border-gray-200 hover:bg-green-50 transition-colors duration-150"
                        >
                          <td className="py-3 px-4 text-sm text-gray-800 font-medium">
                            {new Date(item.date).toLocaleDateString('es-MX', {
                              year: 'numeric',
                              month: 'long',
                              day: 'numeric'
                            })}
                          </td>
                          <td className="py-3 px-4 text-right">
                            <span className="inline-flex items-center justify-center bg-green-600 text-white text-sm font-bold px-3 py-1 rounded-full min-w-[50px]">
                              {item.users}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="text-center py-12">
                  <IconLogin className="mx-auto text-gray-400 mb-3" size={64} />
                  <p className="text-gray-500 text-lg">No hay datos de acceso disponibles</p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardInter;
